import ContextMenuDivider from './components/context-menu-divider'
import ContextMenuItem from './components/context-menu-item'
import ContextMenuList from './components/context-menu-list'
import ContextMenuRoot from './components/context-menu-root'
import ContextMenuTrigger from './components/context-menu-trigger'

const ContextMenuComponent = {
  Root: ContextMenuRoot,
  Item: ContextMenuItem,
  List: ContextMenuList,
  Divider: ContextMenuDivider,
  Trigger: ContextMenuTrigger
}

export default ContextMenuComponent
